import React from 'react';
import { Box } from '@mui/material';

import AskDataPanel from '../signals/askData/AskDataPanel';

/**
 * Analyst
 *
 * Full-bleed conversational workbench. No breadcrumbs, no framed box:
 * the panel consumes the entire content area (we cancel .content-body's
 * gutters with negative margins and pin the height to the viewport
 * minus the fixed app header).
 */
const AnalystPage = () => (
  <Box
    sx={{
      ml: 'calc(-1 * var(--sidebar-content-gutter, 30px))',
      // Mirrors .content-body's right padding (14px mobile / 30px desktop).
      mr: { xs: '-14px', md: '-30px' },
      // ContentBody zeroes .content-body's bottom padding on this route
      // and pins its min-height to the space below the header, so this
      // height fills the viewport exactly - no page scroll, no gap.
      // dvh tracks the collapsing URL bar on mobile browsers.
      height: 'calc(100vh - 64px)',
      '@supports (height: 100dvh)': { height: 'calc(100dvh - 64px)' },
      minHeight: { xs: 0, md: 480 },
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <AskDataPanel />
  </Box>
);

export default AnalystPage;
